import React from 'react';
import { Link } from 'react-router-dom';
import { Translate } from '../common/Translate';

export const MetaData = props => {

    const { subAktif, setSubAktif } = props;

    return (
        <div className="first-level__sub-items">
            <ul className="second-level">
                <li className="second-level__item">
                    <svg className="icon second-level__icon">
                        <use xlinkHref="../img/sprite.svg#icon-list"></use>
                    </svg>
                    <Link className={`second-level__definition${(subAktif === 'firmalar' ? ' active' : '')}`}  to="/account" onClick={e => { setSubAktif('firmalar'); }}>
                        <span className="second-level__span">
                            <Translate>Firmalar</Translate>
                        </span>
                    </Link>
                </li>
                <li className="second-level__item">
                    <svg className="icon second-level__icon">
                        <use xlinkHref="../img/sprite.svg#icon-list"></use>
                    </svg>
                    <Link className={`second-level__definition${(subAktif === 'giderturleri' ? ' active' : '')}`}  to="/expense-type" onClick={e => { setSubAktif('giderturleri'); }}>
                        <span className="second-level__span">
                            <Translate>Gider Türleri</Translate>
                        </span>
                    </Link>
                </li>
            </ul>
        </div>
    )
}